import React from "react";

const TruckCabinGateout = (props) => (
  <svg
    width="217px"
    id="prefix__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 236 169.7"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {`.prefix__st0{fill:${props.background}}.prefix__st1,.prefix__st2{fill:none}.prefix__st2{stroke:${props.border};stroke-width:2;stroke-miterlimit:10}.prefix__st6{fill:${props.color}}.prefix__st8{font-size:10px}`}
    </style>
    <path
      className="prefix__st0"
      d="M178.6 158.7v10H57.4v-10M20.9 75.7v-8.8c0-4.6 3.7-8.4 8.3-8.4v64.1H25c-2.3 0-4.1-1.8-4.1-4.1V86.9M215.4 75.5v-8.7c0-4.6-3.7-8.4-8.3-8.4v64.1h4.3c2.3 0 4.1-1.8 4.1-4.1V86.9M29.3 54.4v104.3h177.5V54.4"
    />
    <path
      className="prefix__st0"
      d="M206.8 58V42.5c0-3.1-.5-6.3-1.6-9.2-2.5-6.8-7.7-12.3-14.3-15.2C171.9 9.8 165.2 1 118 1c-46.9 0-54.7 9-72.9 17.2-6.6 2.9-11.7 8.4-14.2 15.1-1.1 3-1.6 6.1-1.6 9.2v15.4M216.9 75.2h6.5c6.4 0 11.6 5.2 11.6 11.7h-21.9V79c0-2.1 1.6-3.8 3.8-3.8-.1 0 0 0 0 0z"
    />
    <path
      className="prefix__st0"
      d="M78.1 56.6l1.4-19.9c1.4-18.7 16-33.6 34.6-35.4 2.6-.3 5.2-.3 7.8 0 9.1.9 17.5 4.9 23.9 11.4 6.3 6.5 10.2 15 10.8 24l1.4 19.9"
    />
    <path className="prefix__st1" d="M184.2 60.4V15" />
    <path
      className="prefix__st0"
      d="M53.4 14.1L52 60.4M22.9 81.1h6.3v5.8h-6.3zM206.8 81.1h6.3v5.8h-6.3zM194.1 143c2.9 0 5.2-1.9 5.2-4.2M36.8 138.7c0 2.3 2.3 4.2 5.2 4.2"
    />
    <path className="prefix__st1" d="M42 143h152.1" />
    <path
      className="prefix__st0"
      d="M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M199.3 66.7c0-1.9-1.6-3.6-3.9-4.1"
    />
    <path className="prefix__st1" d="M36.8 138.7v-72M199.3 138.7v-72" />
    <path
      className="prefix__st0"
      d="M195.4 62.6c2.3.5 3.9 2.2 3.9 4.1M118 54.4c26 0 52 2.7 77.4 8.2 2.3.5 3.9 2.2 3.9 4.1v72c0 2.3-2.3 4.2-5.2 4.2H42c-2.9 0-5.2-1.9-5.2-4.2v-72c0-1.9 1.6-3.6 3.9-4.1 25.4-5.5 51.3-8.2 77.3-8.2zM22.9 86.9H1c0-6.4 5.2-11.7 11.7-11.7h6.5c2.1 0 3.7 1.7 3.7 3.7v8z"
    />
    <path
      className="prefix__st2"
      d="M178.6 158.7v10H57.4v-10M20.9 75.7v-8.8c0-4.6 3.7-8.4 8.3-8.4v64.1H25c-2.3 0-4.1-1.8-4.1-4.1V86.9M215.4 75.5v-8.7c0-4.6-3.7-8.4-8.3-8.4v64.1h4.3c2.3 0 4.1-1.8 4.1-4.1V86.9M29.3 54.4v104.3h177.5V54.4"
    />
    <path
      className="prefix__st2"
      d="M206.8 58V42.5c0-3.1-.5-6.3-1.6-9.2-2.5-6.8-7.7-12.3-14.3-15.2C171.9 9.8 165.2 1 118 1c-46.9 0-54.7 9-72.9 17.2-6.6 2.9-11.7 8.4-14.2 15.1-1.1 3-1.6 6.1-1.6 9.2v15.4M216.9 75.2h6.5c6.4 0 11.6 5.2 11.6 11.7h-21.9V79c0-2.1 1.6-3.8 3.8-3.8-.1 0 0 0 0 0z"
    />
    <path
      className="prefix__st2"
      d="M78.1 56.6l1.4-19.9c1.4-18.7 16-33.6 34.6-35.4 2.6-.3 5.2-.3 7.8 0 9.1.9 17.5 4.9 23.9 11.4 6.3 6.5 10.2 15 10.8 24l1.4 19.9M184.2 60.4V15M53.4 14.1L52 60.4M22.9 81.1h6.3v5.8h-6.3zM206.8 81.1h6.3v5.8h-6.3zM194.1 143c2.9 0 5.2-1.9 5.2-4.2M36.8 138.7c0 2.3 2.3 4.2 5.2 4.2M42 143h152.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M40.6 62.6c-2.3.5-3.9 2.2-3.9 4.1M199.3 66.7c0-1.9-1.6-3.6-3.9-4.1M36.8 138.7v-72M199.3 138.7v-72M195.4 62.6c2.3.5 3.9 2.2 3.9 4.1"
    />
    <path
      className="prefix__st2"
      d="M118 54.4c26 0 52 2.7 77.4 8.2 2.3.5 3.9 2.2 3.9 4.1v72c0 2.3-2.3 4.2-5.2 4.2H42c-2.9 0-5.2-1.9-5.2-4.2v-72c0-1.9 1.6-3.6 3.9-4.1 25.4-5.5 51.3-8.2 77.3-8.2zM22.9 86.9H1c0-6.4 5.2-11.7 11.7-11.7h6.5c2.1 0 3.7 1.7 3.7 3.7v8z"
    />
    <text
      transform="translate(71.52 104.058)"
      fontSize={20}
      fontFamily="OpenSans-Bold"
      fill={props.primaryColor}
      fontWeight="bold"
    >
      {`Route: ${props.route}`}
    </text>
    <text
      transform="translate(79.724 122.953)"
      className="prefix__st6 prefix__st8"
      fontFamily="OpenSans-Regular"
      fontWeight="bold"
    >
      {`Start time: ${props.time}`}
    </text>
    <text
      transform="translate(81.52 81.203)"
      // className="prefix__st6 prefix__st8"
      fontFamily="OpenSans-Regular"
      fontWeight="bold"
      fontSize={15}
      fill={props.border}
    >
      Dispatched
    </text>
  </svg>
);

export default TruckCabinGateout;
